/**
 * Colors that will be used throught the app.
 */

export default {
  chartPrimary: '#58e2c2',
  primary: '#58e2c2',
  chartSecondary: '#1b2342',
  chartTertiary: '#7440fb',
  chartFourthColor: '#fe60c7',
  white: '#ffffff',
  closeDialogBtn: '#c8c7c7',
  addWidgetBtn: '#d8d8d8',
  addWidgetBtnDark: '#4e4e4e',
  addWidgetBtnOuter: '#323d68',
  secondaryBlack: '#525252'
};
